import React from 'react';
import "./style.css";


function Header({ title, caption }) {
    return (
        <div className='font-serif text-white bg-gradient'>
            <img src={require("../../assets/carousel/strategy2.webp")} alt='' className='w-full h-[100vh] object-cover' />
            <div className="absolute z-10 transform -translate-y-1/2 top-1/2 md:left-1/2 md:-translate-x-1/2" aria-hidden="true">
                <h1 className='text-5xl font-bold text-center'>{title}</h1>
                <p className='px-10 pb-10 my-4 text-lg font-medium text-center md:px-20'>{caption}</p>
            </div>
        </div>
    )
}

export default Header